import { render, staticRenderFns } from "./backoffice-agencia-transfusional.vue?vue&type=template&id=19b5d641&scoped=true"
import script from "./backoffice-agencia-transfusional.vue?vue&type=script&lang=ts"
export * from "./backoffice-agencia-transfusional.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-agencia-transfusional.vue?vue&type=style&index=0&id=19b5d641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5d641",
  null
  
)

export default component.exports